<div class="grid">
    <div class="col-12">
        <div class="card">
            <form #form="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="loadingGeral">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="p-fluid p-formgrid grid" *ngIf="usuario && !loadingGeral">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="nome">Nome</label>
                            <label class="form-control">{{ usuario.nome }}</label>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="email">E-mail</label>
                            <label class="form-control">{{ usuario.email }}</label>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="cpf">CPF</label>
                            <label class="form-control">{{ usuario.cpf | cpfFormat }}</label>
                        </div>
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div class="col-12">
                            <h5>Permissões Adicionadas</h5>
                        </div>
                        <div class="col-12">
                            <p-table
                                [value]="listaPermissoes"
                                dataKey="descricao"
                                [expandedRowKeys]="expandedRows"
                                responsiveLayout="scroll"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 3rem"></th>
                                        <th pSortableColumn="name">
                                            Permissão
                                            <p-sortIcon field="name"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-expanded="expanded">
                                    <tr>
                                        <td>
                                            <button
                                                type="button"
                                                pButton
                                                pRipple
                                                [pRowToggler]="item"
                                                class="p-button-text p-button-rounded p-button-plain"
                                                [icon]="
                                                    expanded
                                                        ? 'pi pi-chevron-down'
                                                        : 'pi pi-chevron-right'
                                                "
                                                style="box-shadow: none"
                                            ></button>
                                        </td>
                                        <td>{{ item.descricao }}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="rowexpansion" let-item>
                                    <tr>
                                        <td colspan="7">
                                            <div class="pl-8">
                                                <p-table
                                                    [value]="item.permissoes"
                                                    dataKey="id"
                                                    responsiveLayout="scroll"
                                                >
                                                    <ng-template pTemplate="body" let-permissao>
                                                        <tr>
                                                            <td colspan="7">
                                                                <span>
                                                                    <i class="pi pi-check mr-1"></i>
                                                                    {{ permissao.descricao }}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="emptymessage">
                                                        <tr>
                                                            <td colspan="7">
                                                                Nenhum registro encontrado
                                                            </td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loadingGeral">
                        <div class="field col-12 md:col-2">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-primary mt-5"
                                routerLink="/rfarias/usuario-franquia"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
